export default "__VITE_ASSET__4YxhBagX__"